import { format } from 'date-fns';

import { formatDuration } from '../../../../../../utils/dateUtils';
import { Meeting } from '../../../../types/timeline';
import { getTimeInTeamTimezone } from '../../../../utils/timelineUtils';

interface MeetingsDetailViewProps {
  meetings: Meeting[];
}

export function MeetingsDetailView({
  meetings,
}: MeetingsDetailViewProps): JSX.Element {
  return (
    <div className="space-y-3">
      {meetings.map((meeting) => (
        <div key={meeting.id} className="flex items-center gap-3">
          <div className="text-gray-600 w-24 flex-shrink-0">
            {format(getTimeInTeamTimezone(meeting.start_time), 'h:mm aaa')} :
          </div>
          <div className="text-gray-900">
            {meeting.title} ({formatDuration(meeting.duration_minutes / 60)})
          </div>
        </div>
      ))}
    </div>
  );
}
